// extracted by mini-css-extract-plugin
export var button = "_im-0";
export var donut = "_im-1";
export var donutFill = "_im-3";
export var donutTrack = "_im-2";